const formatTWPhone = (phoneNumber) => {
    if (phoneNumber.startsWith('+886')) {
        // 替換為 0 開頭，並去掉 +886
        return '0' + phoneNumber.slice(4);
    }
    return phoneNumber; // 若不符合則返回原始號碼
}

export default formatTWPhone;